"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createReducer;

var _normalized = require("./normalized");

function createReducer(schema, version, groupBys) {
  // Handle common scenario, no groupBys
  if (groupBys.length === 1) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        version: version
      };
      var action = arguments.length > 1 ? arguments[1] : undefined;
      if (action.schema !== schema) return state;
      var next = (0, _normalized.reducer)(state._, action);
      if (next === state._) return state;
      return {
        _: next,
        version: version
      };
    };
  }

  var reducers = {
    _: _normalized.reducer
  };
  groupBys.forEach(function (groupBy) {
    reducers[groupBy.name] = groupBy.getReducer();
  });
  var reducerKeys = Object.keys(reducers); // The schema reducer

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      version: version
    };
    var action = arguments.length > 1 ? arguments[1] : undefined;
    if (action.schema !== schema) return state;
    var hasChanged = false;
    var nextState = {
      version: version
    };

    for (var i = 0; i < reducerKeys.length; i += 1) {
      var key = reducerKeys[i];
      var reducer = reducers[key];
      var prevStateForKey = state[key];
      var nextStateForKey = reducer(prevStateForKey, action);
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== prevStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sharingapples/redux/dist/schema/createReducer.js
// module id = 1350
// module chunks = 2